import React from 'react';
import { View, TextInput, StyleSheet, ScrollView, Alert } from 'react-native';
import {connect} from 'react-redux';

import Colors from '../../constants/Colors';
import {ButtonWithSpinner, InformationDialogue, SpinnerDialogue,} from '../../components';

import { getPosts, sendMuralPostAsync, muralPostUpdate, } from '../../redux/actions';
import NavBar from "../../components/NavBar";

class PostWriteScreen extends React.Component {

    state = {
        showSuccessModal: false,
        showErrorModal: false,
    }

    handlePostWriting(newPostData) {
        this.props.muralPostUpdate(newPostData)
    }

    handlePostSend = async () => {

        try {
            const { userId, userName, avatarColor, postText, authToken } = this.props;
            await this.props.sendMuralPostAsync(
                userId,
                userName,
                avatarColor,
                postText,
                //this.state.imageData,
                null,
                authToken
            );

            //Update all the posts
            await this.props.getPosts(this.props.authToken);
            this.setState({ showSuccessModal: true });
        } catch (e) {
            console.log(e);
            this.setState({ showErrorModal: true })
        }
    };

    render() {
        return (

            <NavBar title={"Post"}>


                <InformationDialogue
                    isModalVisible={this.state.showErrorModal}
                    titleText={"Erro"}
                    descriptionText={"Aconteceu um erro ao enviar o post! Tente novamente mais tarde."}
                    onClose={() => this.setState({ showErrorModal: false })}
                />

                <InformationDialogue
                    isModalVisible={this.state.showSuccessModal}
                    titleText={"Sucesso"}
                    descriptionText={"Post enviado com sucesso!"}
                    onClose={() => this.props.history.goBack()}
                />


                <View Style={{ width: 600, alignItems: 'center'}}>

                    <View style={{
                        width: 600,
                        minHeight: 280,
                        backgroundColor: 'white',
                        marginTop: 20,
                    }}>

                        <TextInput
                            editable={true}
                            maxLength={280}
                            multiline
                            placeholder='Escreva seu post'
                            style={{
                                flex: 1,
                                margin: 20,
                                textAlignVertical: 'top',
                            }}
                            onChangeText={(newText) => this.handlePostWriting(newText)}
                            value={this.props.postText}
                        />
                    </View>
                    <ButtonWithSpinner
                        isLoading={this.props.isSending}
                        size={'large'}
                        text={'Enviar'}
                        onPress={() => this.handlePostSend()}
                        containerPropsStyle={styles.sendButtonContainerPropsStyle}
                    />
                </View>
            </NavBar>
        )
    }
}

const styles = StyleSheet.create({
    mainContainer: {
        flex: 1,
        backgroundColor: Colors.backgroundColor,
        // alignItems: 'center',
    },
    sendButtonContainerPropsStyle: {
        marginBottom: 10,
        marginTop: 10,
        height: 40,
        borderRadius: 8,

        backgroundColor: Colors.customRedColor,
        borderColor: Colors.customRedColor,
    }
});

const mapStateToProps = state => {
    console.log(state)
    return {
        userId: state.user.userId,
        userName: state.user.userName,
        avatarColor: state.user.avatarColor,
        isSending: state.post.isSending,
        postText: state.post.postText,
        // authToken: state.auth.authData.IdToken,
        errorText: state.post.error
    }
};

export default connect(mapStateToProps, { getPosts, sendMuralPostAsync, muralPostUpdate, })(PostWriteScreen);
